import { FapBaseModel } from '../../base/fap-base-model';

export class SensorModel extends FapBaseModel {
    public static fields: Array<string> = [
        'id',
        'name',
        'object_id',
        'unit_type',
        'device',
        'type',
        'data',
        'last_value',
        'icon',
        'name_t',
        'representation'
    ];

    public static requiredFields: Array<string> = [
        'id'
    ];

    public static extendedFields: {} = {
    };

    public id: number;
    public name: string;
    public objectId: number;
    public unitType: number;
    public device: string;
    public type: string;
    public data: any;
    public lastValue : any
    public icon: any;
    public nameT: string;
    public representation: any;
}
